import './styles.scss';
import { registerFragment } from "@neptune/cx/registry";
import { DisposalSet } from "@neptune/cx/utils";

const gc = new DisposalSet();

registerFragment('chroa-4-col-row', (fragmentElement, config, meta) => { });

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
